module.exports = __webpack_public_path__ + "static/media/royal-arsenal.8727a078.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/royal-arsenal.jpg
// module id = 296
// module chunks = 0